"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNpcDefinition = isNpcDefinition;
exports.getInlineNpcUpdateScript = getInlineNpcUpdateScript;
/**
 * A character participates in the NPC update system if it is explicitly marked `isNpc`,
 * has an inline `updateScript`, or has an `updateScriptId` (future lazy-loaded scripts).
 */
function isNpcDefinition(character) {
    if (!character)
        return false;
    if (character.isNpc === true)
        return true;
    if (character.updateScriptId != null && String(character.updateScriptId).trim() !== '')
        return true;
    if (character.updateScript != null && String(character.updateScript).trim() !== '')
        return true;
    return false;
}
/** Inline update script body for Phase 1 (Phase 2+ may resolve `updateScriptId`). */
function getInlineNpcUpdateScript(character) {
    if (!character?.updateScript)
        return '';
    return String(character.updateScript).trim();
}
//# sourceMappingURL=npcCharacter.js.map